import { render, staticRenderFns } from "./FailedBeneficiaries.vue?vue&type=template&id=7896e70e&"
import script from "./FailedBeneficiaries.vue?vue&type=script&lang=js&"
export * from "./FailedBeneficiaries.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports